'use strict';
const BaggagesOptionsModel = require('../models/baggages_options');
const BaggageSelectionModel = require('../models/baggages_selection');
const baggagesOptionsCollection = require('../collections/baggages_row_options').getInstance();
const baggagesRowsCollection = require('../collections/baggages_rows').getInstance();
const boardingOptionsCollection = require('../collections/boarding_options/boarding_options.collection').getInstance();

const PRIME_DISCOUNT_AMOUNT_THRESHOLD = 10;

const BaggagesCollectionBuilder = function() {
    this.ROW_IDS = Odigeo._.clone(baggagesRowsCollection.ROW_IDS);
    this.baggagesOptionsModel = BaggagesOptionsModel.getInstance();
    this.baggagesSelectionModel = BaggageSelectionModel.getInstance();
    this.init();
};

const getMostDiscountedPrimeSelectableBag = (data = {}) => {
    const segments = (data?.baggage || [])[0]?.segmentBaggages || [];
    return segments.reduce((acc, segment) => {
        const selectableBags = segment.selectableBaggageDescriptor || [];
        return selectableBags.reduce((acc, selectableBag) => {
            const bag = selectableBag.baggageDescriptor;
            const piecesToShow = bag.piecesToShow;
            const rawPrice = bag.price || 0;
            let discount = 0;

            if (piecesToShow > 0 && rawPrice > 0) {
                const price = rawPrice / piecesToShow;
                const primePrice = (bag.primePrice || rawPrice) / piecesToShow;
                const primeDiscount = price - primePrice;
                discount = primeDiscount > 0
                    ? Odigeo._.ceil(primeDiscount / price * 100)
                    : 0;
            }

            return discount > acc.discount ? {discount, bag} : acc;
        }, acc);
    }, {
        discount: 0,
        bag: null,
    });
};

let instance;

const TRIP_TYPE = {
    'ONE_WAY': 'OW',
    'ROUND_TRIP': 'RT',
    'MULTIPLE_DESTINATIONS': 'MD',
};
const BAGGAGE_TYPES = {
    applicationLevel: 'APPLICATION_LEVEL',
    rowIds: 'ROW_IDS',
    requestType: 'REQUEST_TYPE',
};

Odigeo._.extend(BaggagesCollectionBuilder.prototype, Backbone.Events, {
    ROW_IDS: null,
    viewClass: null,
    collectionBuilt: false,
    pureTrainItinerary: false,
    hasAnyTrainSegment: false,
    baggagesInformation: [],
    init() {
        this.bindEvents();
    },
    clearCollections() {
        baggagesOptionsCollection.clearCollection();
        baggagesRowsCollection.clearCollection();
    },
    buildCollection() {
        const isPaymentPage = Odigeo.History.getPageNameFromFragment() === 'payment';

        this.clearCollections();
        this.requestBaggagesOptions();

        if (isPaymentPage) {
            this.requestCabinBagsOptions();
        }
    },

    bindEvents() {
        this.listenTo(this.baggagesOptionsModel, 'responseIsOK', this.buildOptionsFromRequest);
        this.listenTo(this.baggagesOptionsModel, 'responseIsOK', this.removeLoadingBaggages);
        this.listenTo(this.baggagesOptionsModel, 'responseIsKO', Odigeo._.bind(this.removeLoadingBaggages, this));
        this.listenTo(this.baggagesSelectionModel, 'responseIsOK', this.updateSelectionFromShoppingCart);
        this.listenTo(
            boardingOptionsCollection,
            'responseIsOK',
            Odigeo._.bind(boardingOptionsCollection.updateShoppingCart, boardingOptionsCollection)
        );
    },
    requestBaggagesOptions() {
        this.baggagesOptionsModel.fetch(this.baggagesOptionsModel.getDataRequestSettings());
    },
    requestBaggagesSelection() {
        this.baggagesSelectionModel.fetch(this.baggagesSelectionModel.getDataRequestSettings());
    },
    requestCabinBagsOptions() {
        boardingOptionsCollection.fetch(boardingOptionsCollection.getDataRequestSettings());
    },
    removeLoadingBaggages() {
        this.trigger('removeLoadingBaggages');
    },
    addBagsIfTrain(data) {
        Odigeo._.forEach(data.baggage, (baggage) => {
            const segmentBaggages = baggage.segmentBaggages || [];
            segmentBaggages.map((segment) => {
                if (segment.transportType === 'TRAIN') {
                    segment.baggageDescriptorIncludedInPrice.pieces = ['2A', 'R1'].includes(segment.carrier.code) ? 1 : 2;
                    baggage.includedBaggage = true;
                    baggage.notBaggageAllowed = false;
                }
            });
        });
    },

    buildOptionsFromRequest(data) {
        if (!Odigeo._.isEmpty(data)) {
            const dataObject = data.getAll();
            this.initIsPureTrain(dataObject);
            this.initHasTrainSegment(dataObject);
            this.initPrimeInfo(dataObject);

            this.addBagsIfTrain(dataObject);

            baggagesRowsCollection.setAutoSelectionEnabled(dataObject.autoSelection);

            Odigeo._.each(dataObject.baggage, this.addPassengerBaggagesToCollection, this);

            baggagesRowsCollection.setBaggageBundleDiscountPercentage(dataObject.baggageBundleDiscountPercentage);

            this.setAllowRowsAutoselection(dataObject.baggage);
            this.requestBaggagesSelection();
        }
    },
    setAllowRowsAutoselection(baggageData) {
        baggagesOptionsCollection.setAllowRowsAutoselection(Odigeo._.reduce(baggageData, function(allowRowsAutoselection, passengerBaggageData) {
            return allowRowsAutoselection && passengerBaggageData.autoSelection;
        }, true));
    },
    areAllPassengersWithBaggage(data) {
        return Odigeo._.every(data, (passanger)=> {
            return Odigeo._.every(passanger, (baggageInfo) => {
                return Odigeo._.every(baggageInfo?.selectedBaggageDescriptor, (selectedBaggageDescriptor) => {
                    return selectedBaggageDescriptor.baggageDescriptor.pieces > 0;
                });
            });
        });
    },
    updateSelectionFromShoppingCart(data) {
        if (!Odigeo._.isEmpty(data)) {
            baggagesOptionsCollection.selectedInCartTotalPrice = 0;
            Odigeo._.each(data.getAll(), this.updatePassengerFromCartInfo, this);
        }
        baggagesOptionsCollection.updateTotalInCartFromTotalPrice(this.areAllPassengersWithBaggage(data.getAll()));
        this.collectionPostBuildProcess();
        this.collectionBuilt = true;
        Odigeo.trigger('baggagesObserver:onBaggageLoaded');
    },
    collectionPostBuildProcess() {
        var firstPassengerInformation = this.baggagesInformation[0];
        var requestType = Odigeo._.isUndefined(firstPassengerInformation) ? '' : firstPassengerInformation.searchRequestType;

        baggagesOptionsCollection.calculateIncludedPieces();
        baggagesRowsCollection.setRequestType(requestType);
        this.triggerCollectionBuilt();
    },
    triggerCollectionBuilt() {
        this.trigger('collectionBuilt', this.baggagesInformation);
    },
    addBaggagesRowInfo(baggagesRowInfo, metas) {
        baggagesRowsCollection.fillData(baggagesRowInfo, metas);
    },
    addBaggagesOptions(baggagesOptions, metas) {
        baggagesOptionsCollection.fillData(baggagesOptions, metas);
    },
    addPassengerBaggagesToCollection(passengerBaggage, travellerId) {
        var paxIndex = parseInt(travellerId, 10);
        if (!Odigeo._.isEmpty(passengerBaggage.segmentBaggages)) {
            Odigeo._.each(passengerBaggage.segmentBaggages, function(baggagesRowInfo, index) {
                var metas = {
                    rowType: this.parseRowType(baggagesRowInfo),
                    hasIncludedBaggages: this.hasIncludedBaggages(baggagesRowInfo),
                    hasSelectableBaggages: this.hasSelectableBaggages(baggagesRowInfo),
                    shouldDisplayGenericLogo: !baggagesRowInfo.sameCarrierAllSections,
                    idRow: this.ROW_IDS[index],
                    idPassenger: paxIndex,
                };
                this.addBaggagesRowInfo(baggagesRowInfo, metas);
                this.addBaggageDescriptors(baggagesRowInfo, metas);
            }, this);
            this.baggagesInformation[paxIndex] = passengerBaggage;
        }
    },
    addBaggageDescriptors(baggagesRowInfo, metas) {
        if (metas.hasIncludedBaggages) {
            this.addIncludedBaggageDescriptor(baggagesRowInfo.baggageDescriptorIncludedInPrice, metas);
        }
        if (metas.hasSelectableBaggages) {
            this.addSelectableBaggageDescriptors(baggagesRowInfo.selectableBaggageDescriptor, metas);
        }
    },
    addIncludedBaggageDescriptor(baggageDescriptorIncludedInPrice, metas) {
        baggageDescriptorIncludedInPrice.price = 0;
        this.addBaggagesOptions([baggageDescriptorIncludedInPrice], Odigeo._.extend(metas, {isIncludedBaggage: true, isSelectableBaggage: false}));
        baggagesOptionsCollection.selectDefaultOption(metas.idPassenger, metas.idRow);
    },
    addSelectableBaggageDescriptors(selectableBaggageDescriptors, metas) {
        var baggagesOptions = this.parseDescriptors(selectableBaggageDescriptors);
        this.addBaggagesOptions(baggagesOptions, Odigeo._.extend(metas, {isIncludedBaggage: false, isSelectableBaggage: true}));

        baggagesOptionsCollection.selectDefaultOption(metas.idPassenger, metas.idRow);
    },
    updatePassengerFromCartInfo(passengerSelection, index) {
        var idPassenger = parseInt(index, 10);

        Odigeo._.each(passengerSelection, function(BaggageSelectionResponseDTO) {
            var selectedDescriptors = BaggageSelectionResponseDTO.selectedBaggageDescriptor;
            var selectedDescriptor = Odigeo._.get(selectedDescriptors, 0);
            if (!Odigeo._.isUndefined(selectedDescriptor)) {
                const price = selectedDescriptor.price || 0;
                const primePrice = selectedDescriptor.primePrice || price;

                var pattern = {
                    idPassenger: idPassenger,
                    pieces: selectedDescriptor.baggageDescriptor.pieces,
                    kilos: selectedDescriptor.baggageDescriptor.kilos,
                    price,
                };
                var newOption;
                var isSegment = BaggageSelectionResponseDTO.baggageApplicationLevel === 'SEGMENT';
                var idRowPattern = isSegment ? {idRow: BaggageSelectionResponseDTO.segmentTypeIndexDTO} : {};

                Odigeo._.extend(pattern, idRowPattern);
                newOption = !Odigeo._.isEmpty(selectedDescriptor.baggageDescriptor) ? baggagesOptionsCollection.getOption(pattern) : {};

                if (!Odigeo._.isEmpty(newOption)) {
                    baggagesOptionsCollection.updateOption(newOption.cid);

                    baggagesOptionsCollection.addPerksFromDapi(newOption.get('idRow'),
                        idPassenger, price, primePrice);
                    baggagesOptionsCollection.updateShoppingCart(newOption);
                }
            }
        }, this);
    },
    parseDescriptors(selectableDecriptors) {
        return Odigeo._.map(selectableDecriptors, function(singleSelectableDescriptor) {
            var descriptor = singleSelectableDescriptor.baggageDescriptor;

            descriptor.price = singleSelectableDescriptor.price;
            return descriptor;
        });
    },
    isCollectionBuilt() {
        return this.collectionBuilt;
    },
    hasIncludedBaggages(baggagesRowInfo) {
        return !Odigeo._.isEmpty(baggagesRowInfo.baggageDescriptorIncludedInPrice) && baggagesRowInfo.baggageDescriptorIncludedInPrice.pieces > 0;
    },
    hasSelectableBaggages(baggagesRowInfo) {
        return !Odigeo._.isEmpty(baggagesRowInfo.selectableBaggageDescriptor);
    },
    parseRowType(baggagesRowInfo) {
        var hasBaggageIncluded = this.hasIncludedBaggages(baggagesRowInfo);
        var hasBaggageSelectable = this.hasSelectableBaggages(baggagesRowInfo);

        return hasBaggageIncluded && hasBaggageSelectable ? 'BOTH' :
            (hasBaggageIncluded ? 'INCLUDED' : (hasBaggageSelectable ? 'SELECTABLE' : 'NOT_ALLOWED'));
    },
    getMerchandisingDiscountInfo() {
        return baggagesOptionsCollection.getMerchandisingDiscountInfo();
    },
    getDiscountPercentage() {
        return baggagesOptionsCollection.getDiscountPercentage();
    },
    getPrimeDiscountPercentage: function(data = {}) {
        const mostDiscountedOption = getMostDiscountedPrimeSelectableBag(data);
        return mostDiscountedOption.discount || 0;
    },
    getPrimeDiscountAmount: function({baggage}) {
        const passengersNumber = Object.keys(baggage).length;
        let maxSegmentPriceDifferencesSum = (baggage?.[0]?.segmentBaggages ?? []).reduce((acc, cur) => {
            const currentSum = Math.max(
                ...cur.selectableBaggageDescriptor.map(({price, primePrice}) => price - (primePrice || price))
            );

            return acc + currentSum;
        }, 0);

        if (baggage?.[0]?.segmentBaggages?.length === 1 && baggage?.[0].searchRequestType === 'ROUND_TRIP') {
            maxSegmentPriceDifferencesSum *= 2;
        }

        return Math.floor(maxSegmentPriceDifferencesSum * passengersNumber);
    },
    getCheapestSelectableOption() {
        return baggagesOptionsCollection.getCheapestSelectableBag();
    },
    isItineraryTrip() {
        return baggagesRowsCollection.isAnItineraryTrip();
    },
    isBaggageSelected() {
        return baggagesOptionsCollection.selectedPieces;
    },
    doBaggageAllowAutoselection: function() {
        if (Odigeo.AB.isBaggageGroupedBySegment) {
            return baggagesRowsCollection.isAutoSelectionEnabled();
        }

        return baggagesOptionsCollection.doOptionsAllowAutoselection() &&
            baggagesRowsCollection.doRowsAllowAutoselection();
    },
    getBaggagesRequestType: function() {
        return baggagesRowsCollection.requestType;
    },
    getTripTypeId: function() {
        const tripType = this.getBaggagesRequestType();
        return TRIP_TYPE[tripType];
    },
    isBaggagePropensityLowForMerchandisingDiscount() {
        return baggagesOptionsCollection.isBaggagePropensityLowForMerchandisingDiscount();
    },
    getBoardingOptionsTrackingConstant: function() {
        return boardingOptionsCollection.isPriorityOptionsActive()
            ? boardingOptionsCollection.getCarrierSections()
            : '0';
    },
    haveAllSegmentsBagsSelected: function() {
        return this.getAllSelectedBaggageOptions().length === this.getTotalSegmentsWithASelectableBaggage();
    },
    getAllSelectedBaggageOptions() {
        return baggagesOptionsCollection.getAllSelectedBaggageOptions();
    },
    getTotalSegmentsWithASelectableBaggage() {
        return baggagesOptionsCollection.getTotalSegmentsWithASelectableBaggage();
    },
    getFlightsWithBagsSelectedTracking: function() {
        return this.haveAllSegmentsBagsSelected() ?
            'ALL' :
            this.getSegmentsWithBagSelectionFormatted();
    },
    getBaggagesType: function(collectionType) {
        if (Odigeo._.isUndefined(this[collectionType])) {
            this[collectionType] = Odigeo._.clone(baggagesRowsCollection[collectionType]);
        }
        return this[collectionType];
    },
    getBaggagesRowIdsArray: function() {
        return this.getBaggagesType(BAGGAGE_TYPES.rowIds);
    },
    getBaggagesRequestTypesEnum: function() {
        return this.getBaggagesType(BAGGAGE_TYPES.requestType);
    },
    getBaggagesApplicationLevelEnum: function() {
        return this.getBaggagesType(BAGGAGE_TYPES.applicationLevel);
    },
    getRowIdsWithBaggageSelection: function() {
        return Odigeo._.uniq(Odigeo._.map(this.getBaggageSelectedOptionsWithPieces(), function(row) {
            return row.get('idRow');
        }));
    },
    getSelectedKilos: function() {
        return this.getBaggageSelectedOptionsWithPieces().reduce((acc, row) => {
            const pieces = row.get('pieces') || 0;
            const kilos = row.get('kilos') || 0;
            if (pieces > 0) {
                acc.push(kilos);
            }
            return acc;
        }, []);
    },
    getBaggageSelectedOptionsWithPieces: function() {
        return Odigeo._.filter(this.getBaggagesFullSelection(), function(option) {
            return option.get('piecesToShow') > 0;
        });
    },
    getBaggagesFullSelection: function() {
        return baggagesOptionsCollection.getFullSelection();
    },
    getSegmentsWithBagSelectionFormatted: function() {
        const baggageRowIds = this.getBaggagesRowIdsArray();
        const rowIdsWithBaggageSelection = this.getRowIdsWithBaggageSelection();
        const segmentsFormatted = Odigeo._.reduce(rowIdsWithBaggageSelection, function(segments, currentSegment) {
            const indexFound = Odigeo._.indexOf(baggageRowIds, currentSegment);

            if (indexFound >= 0) {
                segments.push(indexFound + 1);
            }

            return segments;
        }, [], this);
        return Odigeo._.isEmpty(segmentsFormatted) ? '0' : segmentsFormatted.join('-');
    },

    initIsPureTrain(data = {}) {
        const segments = (data?.baggage || [])[0]?.segmentBaggages || [];
        const trainSegments = Odigeo._.filter(segments, {transportType: 'TRAIN'});
        this.pureTrainItinerary = trainSegments.length && trainSegments.length === segments.length;
    },
    isPureTrain() {
        return this.pureTrainItinerary;
    },

    initHasTrainSegment(data = {}) {
        const segments = (data?.baggage || [])[0]?.segmentBaggages || [];
        this.hasAnyTrainSegment = Odigeo._.filter(segments, {transportType: 'TRAIN'}).length > 0;
    },
    hasTrainSegment() {
        return this.hasAnyTrainSegment;
    },
    initPrimeInfo(data = {}) {
        const discountPercentage = this.getPrimeDiscountPercentage(data) || 0;
        const discountAmount = this.getPrimeDiscountAmount(data) || 0;
        const hasAValidDiscount = discountPercentage > 0;
        const isBagsPrimeDiscounts = Odigeo.AB.isBagsPrimeDiscountsDesktop || Odigeo.AB.isBagsPrimeDiscountsMobile;
        const shouldDisplayDiscountAsAmount = isBagsPrimeDiscounts && hasAValidDiscount && discountPercentage < PRIME_DISCOUNT_AMOUNT_THRESHOLD
            && discountAmount > discountPercentage;
        const isBaggagePrimePrice = Odigeo.AB.isBaggagePrimePriceMobile || Odigeo.AB.isBaggagePrimePriceDesktop;
        const isPrimeProductOffered = Odigeo.Membership.isMembershipProductEnabled;
        const isUserPrimeMemberAndNotLogged = Odigeo.Membership.isUserPrimeMemberAndNotLogged;
        const isPriceWithDiscountSelected = Odigeo.Membership.isPriceWithoutDiscountSelected === 'false';
        const isPaymentPage = Odigeo.History.getPageNameFromFragment() === 'payment';
        const primeFareOffered = (!isPaymentPage && isPriceWithDiscountSelected)
            || (isPaymentPage && Odigeo.Membership.isMembershipProductEnabled);
        const isPureTrain = this.isPureTrain();
        const memberName = Odigeo.Membership.membershipUserName;
        const isPrimeUser = memberName.length > 0;
        const isPrimeFareOffered = (isUserPrimeMemberAndNotLogged || isPrimeProductOffered)
            && primeFareOffered;

        const isPrimeView = isBaggagePrimePrice
            && !isPureTrain
            && (isPrimeFareOffered || isPrimeUser)
            && hasAValidDiscount;

        baggagesOptionsCollection.setPrimeInfo({
            isPrimeView,
            isPrimeUser,
            memberName,
            discountPercentage,
            discountAmount: shouldDisplayDiscountAsAmount ? discountAmount : 0,
        });
    },
});

module.exports = BaggagesCollectionBuilder;
module.exports.getInstance = () => {
    if (Odigeo._.isUndefined(instance)) {
        instance = new BaggagesCollectionBuilder();
    }

    return instance;
};

